import { container } from "tsyringe";
import type { IEditorSettingsRepository } from "$src/domain/designs/settings/IEditorSettingsRepository";
import { EditorSettingsRepository } from "./designs/settings/EditorSettingsRepository";

container.register<IEditorSettingsRepository>("IEditorSettingsRepository", { useClass: EditorSettingsRepository });
